import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';

import { Config } from '../../config/config';
import { VnptHttpService } from '../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { ICapDonVi } from './cap-don-vi';

@Injectable()

export class CapDonViService {
    
    constructor(private http: Http) { }
   
    GetList() {
        let headers = new Headers();
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.post(Config.apiUrl + 'CapDonVi/GetList', JSON.stringify(data), { headers: headers }).map(resp => resp.json());       
    }

    Save(item?:ICapDonVi) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'CapDonVi/Save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    Delete(item) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + 'CapDonVi/Delete', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    GetListFromPagination(paging:number, keyword: string, pageSize: number) {
        let headers = new Headers();
        let startRowIndex = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {startRowIndex, pageSize};
        return this.http.get(Config.apiUrl + 'CapDonVi/PaginationDSCapDonVi?offset=' + startRowIndex + "&pagesize=" + pageSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());       
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/cap-don-vi/cap-don-vi.service.ts